"use client";

import { generateAmortizationSchedule } from "@/utils/amortization";
import { useMemo } from "react";

const toCurrency = (num: number) => "$" + num.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");

const MortgageAmortizationTable = ({
    loanAmount,
    annualRate,
    loanTerm,
}: {
    loanAmount: number;
    annualRate: number;
    loanTerm: number;
}) => {
    const schedule = useMemo(
        () => generateAmortizationSchedule(loanAmount, annualRate, loanTerm),
        [loanAmount, annualRate, loanTerm],
    );

    return (
        <div className="overflow-x-auto mt-10 2xl:pb-2">
            <h3 className="text-xl font-bold mb-4 text-center text-[#212459]">Monthly Payment Schedule</h3>
            {/*<table className="w-full table-auto border-collapse text-sm bg-white shadow overflow-hidden">*/}
            <table className="w-full table-auto border border-gray-300 border-collapse bg-white shadow">
                <thead className="bg-blue text-white">
                    <tr>
                        <th className="px-3 py-2 text-[15px] border border-gray-300">Month</th>
                        <th className="px-3 py-2 text-[15px] border border-gray-300">Payment</th>
                        <th className="px-3 py-2 text-[15px] border border-gray-300">Balance</th>
                        <th className="px-3 py-2 text-[15px] border border-gray-300">Principal</th>
                        <th className="px-3 py-2 text-[15px] border border-gray-300">Interest</th>
                        <th className="px-3 py-2 text-[15px] border border-gray-300">Cum. Intr.</th>
                    </tr>
                </thead>
                <tbody>
                    {schedule.map((row) => (
                        <tr key={row.month} className="odd:bg-[#f6f9ff] even:bg-white text-center">
                            <td className="px-2 py-1 text-[15px] border border-gray-300">{row.month}</td>
                            <td className="px-2 py-1 text-[15px] border border-gray-300">{toCurrency(row.payment)}</td>
                            <td className="px-2 py-1 text-[15px] border border-gray-300">{toCurrency(row.balance)}</td>
                            <td className="px-2 py-1 text-[15px] border border-gray-300">
                                {toCurrency(row.principal)}
                            </td>
                            <td className="px-2 py-1 text-[15px] border border-gray-300">{toCurrency(row.interest)}</td>
                            <td className="px-2 py-1 text-[15px] border border-gray-300">
                                {toCurrency(row.cumulativeInterest)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default MortgageAmortizationTable;
